import GeoIconArray from './GeoIconArray';
import iconArr from './iconArr';

export default GeoIconArray;
export {iconArr};